<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <Menu/>

          <div class="element-box mb-3 mt-4">
            <h6>Einheiten im Jahr {{ filterData.year }} fertiggestellt</h6>
            <div class="row mt-4">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.coachingType"
                        :options="dropdownCoachingType"
                        :is-clear="false"
                    />
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.year"
                        :options="dropdownYears"
                        :is-clear="false"
                    />
                  </div>
                  <div class="col-lg col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.locationId"
                        placeholder="Standort"
                        :options="dropdownOffices"
                        :is-clear="true"
                    />
                  </div>

                  <div class="col-auto text-center">
                    <button class="btn btn-primary custom_search_button2" @click="getChartBar(true)"
                            :disabled="!isLoaded">
                      <span v-if="isSearching">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('general.button.search_in_progress') }}
                      </span>
                      <span v-else>
                        {{ $t('general.button.search') }}
                      </span>
                    </button>
                  </div>
                </div>
                <VueApexCharts width="100%" type="bar" :options="chartOptionsBar" :series="seriesSignBar"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormSidebar>
        <template #top>
          <h6 class="element-header">
            Sidebar
          </h6>
        </template>
      </FormSidebar>
    </div>
  </div>
</template>

<script setup>
import dashboardAccountantService from '@/api/Dashboard/Accountant';
import FormSidebar from '@/components/FormSidebar.vue';
import SelectVue from '@/components/SelectVue.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { getCoachingTypes, getOfficeDropdown, getYears } from '@/shared/dropdowns';
import { optionsChartBar } from '@/shared/utils/apex';
import { MonthsUtils } from '@/shared/utils/MonthsUtils';
import { piniaUserStore } from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/Accountant/Menu.vue';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import VueApexCharts from 'vue3-apexcharts';

const { t }                = useI18n();
const dropdownYears        = ref([]);
const dropdownCoachingType = ref([]);
const dropdownOffices      = ref([]);
const isLoaded             = ref(false);
const isSearching          = ref(false);
const seriesSignBar        = ref([]);

const chartOptionsBar = ref({
  ...optionsChartBar,
  xaxis: {
    categories: MonthsUtils(t),
  },
  colors: [
    'rgba(67, 173, 78, 0.6)',
    'rgba(75, 192, 192, 0.6)',
  ],
  plotOptions: {
    bar: {
      distributed: false,
    },
  },
});

const filterData = ref({
  coachingType: 'private_coaching',
  year: new Date().getFullYear(),
  locationId: '',
});


async function getChartBar() {
  try {
    isSearching.value = true;
    if (filterData.value.locationId === null || filterData.value.locationId === undefined) {
      filterData.value.locationId = '';
    }
    const { data }      = await dashboardAccountantService.getChartData(filterData.value);
    seriesSignBar.value = [ data.data.chartData.signedUnits, data.data.chartData.unsignedUnits ];

    isSearching.value = false;
  } catch (error) {
    isSearching.value = false;
    await ErrorToast(error);
  }
}

function getDropdowns() {
  getYears(dropdownYears);
  getCoachingTypes(dropdownCoachingType);
  getOfficeDropdown(dropdownOffices);
}

onMounted(async () => {
  CloseToast();
  getDropdowns();
  await getChartBar();

  isLoaded.value = true;
});
</script>

<style scoped>
/* Optional custom styles */
</style>